import CheckboxRow from '../../../partials/dataRows/CheckboxRow';
import InputRow from '../../../partials/dataRows/InputRow';
import { customStylesExchange } from '../styles/informationStep';
import { translate } from '../../../i18n/I18nProvider';
import { isStringDefined } from '../../../utils/isDefined';

const ExchangeBox = ({ fieldProps }) => {
  const { values, setFieldValue } = fieldProps;

  const handleExchangeSyncChange = e => {
    const checked = e.target.checked;
    setFieldValue('exchange_sync', checked);
    if (!checked) {
      setFieldValue('exchange_id', '');
    }
  };

  return (
    <div>
      {isStringDefined(values.copy_from_user) && (
        <CheckboxRow
          labelText="Exchange calendar sync"
          name="exchange_sync"
          customStyles={customStylesExchange.checkbox}
          customCheckFunction={handleExchangeSyncChange}
          {...fieldProps}
        />
      )}
      {values.exchange_sync === true && (
        <InputRow
          label="EXCHANGE_ID"
          name="exchange_id"
          customStyles={customStylesExchange.input}
          isRequired={true}
          infoIcon={true}
          infoIconText={translate('TOOLTIP.EXCHANGE_ID')}
          {...fieldProps}
        />
      )}
    </div>
  );
};

export default ExchangeBox;
